import Integration, { STATUS_DEACTIVATED } from '@/integrations/modules/go/store/models/integration';
import { RIPPLING } from '@/integrations/modules/rippling/consts';
import Integrations from '@/shared/api/integrations';

import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchRippling = createAsyncThunk('rippling/fetchRippling', async (_, { rejectWithValue }) => {
  try {
    const response = await Integrations.get(`/integrations/${RIPPLING}`);
    return new Integration(response.integration);
  } catch (error: any) {
    // Don't throw error for integration not found
    if (error.hasErrorCode?.('INTEGRATION_NOT_FOUND')) {
      return new Integration({
        kind: RIPPLING,
        status: STATUS_DEACTIVATED,
      });
    }
    return rejectWithValue(error);
  }
});
